<template lang="pug">
  v-window(v-model="window")
    v-window-item
      validation-observer(
        v-if="!loading"
        ref="obs"
        v-slot="{ invalid, handleSubmit }"
      )

        v-alert(
          color="info"
          text outlined
        ) Перед формированием счета обязательно проверьте свои реквизиты.

        v-list(outlined).mb-5.pb-0

          v-row.ma-0
            .text-body-1.secondary--text.ml-4: strong Реквизиты
            v-spacer
            template()
            v-chip(
              v-if="!editMode"
              small color="primary"
              @click="handleChangeContractDetails"
            ).mr-2 Изменить
            template(v-else)
              v-chip.mr-2(small @click="closeEdit")
                v-icon(left small) mdi-close
                | Отмена
              tooltip-wrap(text="сохранить")
                v-chip.mr-2(
                  small color='success'
                  @click="updateContractDetails"
                ): v-icon mdi-check

          template(v-if="$user.isOrganization")
            v-list-item.px-0.mx-0
              v-list-item-title Наименование организации
              v-list-item-subtitle {{ $user.organization.full_name }}
            v-list-item
              v-list-item-title Юр. адрес
              v-list-item-subtitle {{ paymentDetails.legal_address }}
            v-list-item
              v-list-item-title № счета
              v-list-item-subtitle {{ paymentDetails.acc }}
            v-list-item
              v-list-item-title ИНН
              v-list-item-subtitle {{ paymentDetails.inn }}
            v-list-item
              v-list-item-title КПП
              v-list-item-subtitle {{ paymentDetails.kpp }}
            v-list-item(v-if="paymentDetails.oktmo")
              v-list-item-title ОКТМО
              v-list-item-subtitle {{ paymentDetails.oktmo }}
            v-list-item(v-if="paymentDetails.kbk")
              v-list-item-title КБК
              v-list-item-subtitle {{ paymentDetails.kbk }}
          template(v-else)
            v-divider.mt-2
            v-list-item.px-0
              v-list-item-title.pl-4(v-if="!isMobile") ФИО
              v-divider(v-if="!isMobile" vertical)
              v-list-item-subtitle
                validation-provider(
                  rules="required"
                  name="ФИО"
                  vid="full_name"
                  v-slot="{ errors }"
                )
                  v-text-field(
                    v-model="userPaymentDetails.full_name"
                    :label="isMobile ? 'ФИО' : ''"
                    hide-details
                    filled :disabled="!editMode"
                    :error-messages="errors"
                  )
            v-divider
            v-list-item.px-0
              v-list-item-title.pl-4(v-if="!isMobile") Адрес
              v-divider(v-if="!isMobile" vertical)
              v-list-item-subtitle
                validation-provider(
                  rules="required"
                  name="Адрес"
                  vid="address"
                  v-slot="{ errors }"
                )
                  v-text-field(
                    v-model="userPaymentDetails.address"
                    :label="isMobile ? 'Адрес' : ''"
                    hide-details
                    filled :disabled="!editMode"
                  )
            v-divider
            v-list-item.px-0
              v-list-item-title.pl-4(v-if="!isMobile") Телефон
              v-divider(v-if="!isMobile" vertical)
              v-list-item-subtitle
                validation-provider(
                  rules="required"
                  name="Телефон"
                  vid="phone"
                  v-slot="{ errors }"
                )
                  maska-field(
                    v-model="userPaymentDetails.phone"
                    :label="isMobile ? 'Телефон' : ''"
                    type="phone"
                    hide-details
                    filled :disabled="!editMode"
                  )

        //- p.text-center Оставшаяся сумма для полной оплаты:
        //-   span.primary--text  {{ contract.maxPayment | humanumber }}
        //-   span  руб.
        v-row.text-sm-h4.text-h5.mb-6.no-wrap(no-gutters)
          v-col(sm="auto" cols="12").pr-2 Сумма для оплаты:
          v-col.secondary--text.font-weight-bold.no-wrap {{ paymentValue | humanumber }} ₽

        .pb-2.text-sm-body-1.pl-1.text-subtitle-2 Укажите адрес электронной почты для получения чека
        v-col(cols="12" sm="8").pa-0
          validation-provider(
            rules="required|email"
            name="Почта"
            vid="email"
            v-slot="{ errors }"
          )
            v-text-field(
              v-model.trim="email"
              name="email"
              label="Почта"
              width="50%"
              persistent-hint
              :error-messages="errors"
              filled
              rounded
            )
        v-btn(
          :disabled="invalid"
          depressed rounded x-large
          @click="startPayment(); window = 1"
          block color="success"
        ) Оплатить
    v-window-item
      div.text-center(v-if="!loadingQr && contract.qr_code && !contract.paymentFeedBack")
        p.text-h4 Cумма для оплаты:
        p.text-h2.secondary--text.font-weight-bold {{ paymentValue | humanumber }}₽
        p Отсканируйте qr-code для оплаты
        v-row(justify="center" ).py-14
          div(v-html="contract.qr_code" style="transform: scale(1.6);")
        p.mt-4
          span.mr-1 или можете
          a(text :href="contract.payment_url" target="_blank").mr-1 оплатить,
          span введя данные карты
      v-alert(
        v-else-if="contract.paymentFeedBack"
        :type="contract.paymentFeedBack.color"
        text outlined
        prominent
      ).d-flex
        span {{ contract.paymentFeedBack.text }}
      v-progress-circular(
        v-else-if="loadingQr"
        indeterminate
        color="priamry"
        size=170
      )
    //- v-row.ma-0
    //-   v-btn(
    //-     v-if="!loadingQr && contract.payment_url"
    //-     x-large
    //-     block
    //-     color="success"
    //-     @click="contract.openPaymentPDF(payment)"
    //-   ).mx-auto Перейти к оплате

</template>
<script>
// import CInput from '@/components/Constructor/CInput.vue';
import MaskaField from '@/components/InputFields/MaskaField.vue';

export default {
  components: {
    MaskaField,
  },
  props: {
    contract: { type: Object, required: true },
    paymentValue: { type: Number, required: true },
  },
  data() {
    return {
      email: '',
      editMode: false,
      payment: null,
      window: 0,
      loading: true,
      paymentDetails: null,
      loadingQr: false,
      userPaymentDetails: { ...this.contract.users[0] },
      options: {
        mask: '# (###) ###-##-##',
      },
    };
  },
  computed: {
    isMobile() {
      return !this.$vuetify.breakpoint.smAndUp;
    },
    route() {
      return { name: this.$user.isOrganization ? 'PaymentAgreements' : 'UserSettings', query: { tab: 2 } };
    },
  },
  async created() {
    if (this.$user.isOrganization) {
      const { data } = await this.$api.contracts.getPayment(this.$user.organization.id);
      this.paymentDetails = data.data.payment_detail;
    }
    const query = { ...this.$route.query };
    if (query.payment) {
      delete query.payment;
      this.$router.push({ query });
    }
    this.loading = false;
  },
  methods: {
    closeEdit() {
      this.userPaymentDetails = { ...this.contract.users[0] };
      this.editMode = false;
    },
    handleChangeContractDetails() {
      if (this.$user.isOrganization) {
        this.$router.push({ name: 'PaymentAgreements', query: { tab: 2 } });
        this.$modals.close();
      } else {
        this.editMode = true;
      }
    },
    updateContractDetails() {
      this.$rHandler(
        this.$api.contracts.updateContractsUsers(this.contract.id, {
          users: [this.userPaymentDetails],
        }),
        () => {
          this.editMode = false;
          this.$emit('save', [this.userPaymentDetails]);
          this.$toasted.success('успешно');
        },
      );
    },
    async startPayment() {
      this.loadingQr = true;
      await this.contract.startPaymentWithQr(this.paymentValue, this.email);
      this.loadingQr = false;
    },
    // success() {
    //   this.contract.setPayment(this.payment);
    //   return true;
    //   // if (this?.paymentDetails?.type === 2) {
    //   // } else this.contract.openPaymentPDF(this.payment);
    // },
  },
};
</script>
<style lang="scss" scoped>
::v-deep input {
    letter-spacing: none;

    &::placeholder {
    letter-spacing: none;
  }
}
</style>
